module.exports = __webpack_public_path__ + "static/media/logo.daa1b3d4.svg";